module.exports = __webpack_public_path__ + "static/media/eKeeper.40c4d85f.jpg";